import { Tooltip, Typography } from '@mui/material';
import { useLayoutEffect, useMemo, useRef, useState } from 'react';
import {
  TabNamePaddingY,
  TabNameStyles,
  TabNameTooltipEnterDelay,
  TabNameTooltipOffsetY,
  TabNameTooltipSlots,
  TabNameTooltipStyles,
} from './TabNameProps';
import { TestIds } from '../../../utils/dataTestIds';

type Props = {
  name: string;
};

export const TabName = ({ name }: Props) => {
  const nameRef = useRef<HTMLSpanElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  const checkTruncation = () => {
    const el = nameRef.current;
    if (!el) return;
    setIsTruncated(el.scrollWidth > el.clientWidth);
  };

  useLayoutEffect(checkTruncation, [name]);

  const slotProps = useMemo(
    () => ({
      ...TabNameTooltipStyles,
      popper: {
        anchorEl: {
          getBoundingClientRect: () => {
            const rect = nameRef.current?.getBoundingClientRect();
            if (!rect) return new DOMRect();
            return new DOMRect(
              rect.x,
              rect.y + TabNamePaddingY + TabNameTooltipOffsetY,
              rect.width,
              rect.height - TabNamePaddingY * 2
            );
          },
        },
      },
    }),
    []
  );

  return (
    <Tooltip
      title={isTruncated ? name : ''}
      placement="top"
      arrow
      disableInteractive
      enterDelay={TabNameTooltipEnterDelay}
      enterNextDelay={TabNameTooltipEnterDelay}
      slots={TabNameTooltipSlots}
      slotProps={slotProps}
    >
      <Typography
        ref={nameRef}
        sx={TabNameStyles}
        component="span"
        onMouseEnter={checkTruncation}
        data-testid={TestIds.MainTabs.TabName}
      >
        {name}
      </Typography>
    </Tooltip>
  );
};
